export default __webpack_public_path__ + "static/media/EM0540.34I-22667_-15282_0.171fcb12.jpg";